import {Component, Input, OnInit} from '@angular/core';
import {IPicture} from '@api/models/image/picture';
import {IMAGE_RESOLUTION} from '@api/models/image/image-resolution';
import {IUTMParameters} from '@utils/services/url/url.service';
import {ColorScheme} from '@lib/models/color-scheme/color-scheme';

export enum ContentCardLayout {
  Split = 'layout-split',
  Stacked = 'layout-stacked',
  Compact = 'layout-compact',
  Square = 'layout-square',
  SquareThumbnail = 'layout-square-thumbnail',
  Minimal = 'layout-minimal'
}

export enum ContentCardAlignment {
  Left = 'left',
  Right = 'right'
}

@Component({
  selector: 'lib-content-card',
  templateUrl: './content-card.component.html',
  styleUrls: ['./content-card.component.scss'],
})
export class LibContentCardComponent implements OnInit {

  @Input() public imageResolution = IMAGE_RESOLUTION.MEDIUM;
  @Input() public colorScheme: ColorScheme = ColorScheme.Dark;
  @Input() public showContent = true;
  @Input() public showVideoIndicator = false;
  @Input() public lazyLoadImage = true;
  @Input() public preloadImage = false;
  @Input() public containImage = false;
  @Input() public minImageHeight: string;
  @Input() private maxImageHeight: string;
  @Input() public aspectRatio: string;
  @Input() public picture: IPicture;
  @Input() public title: string;
  @Input() public preTitle: string;
  @Input() public preview_text: string;
  @Input() public layout: ContentCardLayout;
  // Is only applied when split layout is used
  @Input() public splitAlignment = ContentCardAlignment.Right;
  @Input() public routerLink: string;
  @Input() public linkTarget = '_blank';
  @Input() public utmParams: IUTMParameters;

  protected readonly ContentCardAlignment = ContentCardAlignment;
  protected readonly ContentCardLayout = ContentCardLayout;

  constructor() { }

  ngOnInit(): void { }

  public get showGradient(): boolean {
    return this.layout === ContentCardLayout.Compact || this.layout === ContentCardLayout.SquareThumbnail;
  }

  public getMaxImageHeight() {
    return this.layout === ContentCardLayout.SquareThumbnail ? '170px' : this.maxImageHeight;
  }
}
